import * as AddonController from './AddonController';

export const clientApi = {
  addon: AddonController,
};
